// =====================================================================
// packages/ui/format.js — Formatação e sanitização.
//
// escapeHtml() é o mesmo do MdM (correção F-07 da security review): TODO
// dado que veio do usuário e vai virar innerHTML passa por aqui. Nome de
// inquilino é dado de terceiro — tratar como hostil por padrão.
// =====================================================================

const _MAP = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };

/** Escapa HTML. Use SEMPRE que injetar dado de usuário via innerHTML. */
export function escapeHtml(s) {
  if (s == null) return '';
  return String(s).replace(/[&<>"']/g, c => _MAP[c]);
}

export function moeda(v) {
  const n = Number(v || 0);
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export function data(d) {
  if (!d) return '';
  const dt = typeof d === 'string' ? new Date(d + (d.length === 10 ? 'T12:00:00' : '')) : d;
  return dt.toLocaleDateString('pt-BR');
}

/** '2026-07-01' → 'julho/2026' */
export function competencia(d) {
  if (!d) return '';
  const dt = new Date(String(d).slice(0, 10) + 'T12:00:00');
  return dt.toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
}

export function cpf(v) {
  const s = String(v || '').replace(/\D/g, '');
  if (s.length !== 11) return v || '';
  return s.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function telefone(v) {
  const s = String(v || '').replace(/\D/g, '').replace(/^55/, '');
  if (s.length === 11) return s.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
  if (s.length === 10) return s.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
  return v || '';
}

/** Dias de atraso (negativo = ainda vai vencer). */
export function diasAtraso(vencimento) {
  if (!vencimento) return 0;
  const v = new Date(String(vencimento).slice(0, 10) + 'T12:00:00');
  const hoje = new Date();
  hoje.setHours(12, 0, 0, 0);
  return Math.round((hoje - v) / 86400000);
}

/** Rótulo e cor de status — usado nos badges da UI. */
export function statusCobranca(c) {
  const d = diasAtraso(c.vencimento);
  if (c.status === 'paga')           return { txt: 'Paga',           cor: 'verde'   };
  if (c.status === 'em_conferencia') return { txt: 'Em conferência', cor: 'ambar'   };
  if (c.status === 'paga_parcial')   return { txt: 'Parcial',        cor: 'ambar'   };
  if (c.status === 'cancelada')      return { txt: 'Cancelada',      cor: 'cinza'   };
  if (d > 0)                         return { txt: `Atrasada ${d}d`, cor: 'vermelho'};
  return { txt: 'Em aberto', cor: 'azul' };
}
